/**
 * @generated SignedSource<<277996f195fd7c73be7b4e54b4838b8b>>
 * @relayHash a5b790ed65d0de142da6e4d1622295fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2

import type { ConcreteRequest } from 'relay-runtime';
export type BulkRoleAssignmentSpaceType = "COLLABORATION" | "GLOBAL" | "KNOWLEDGE_BASE" | "PERSONAL" | "%future added value";
export type RoleAssignmentPrincipalType = "ACCESS_CLASS" | "APP" | "GROUP" | "USER" | "%future added value";
export type useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation$variables = {
  principalId: string;
  principalType: RoleAssignmentPrincipalType;
  roleId: string;
  spaceTypes: ReadonlyArray<BulkRoleAssignmentSpaceType | null | undefined>;
};
export type useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation$data = {
  readonly bulkSetRoleAssignmentToSpaces: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
    readonly taskId: string | null | undefined;
  } | null | undefined;
};
export type useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = {
  response: useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation$data;
  variables: useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "principalId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "principalType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceTypes"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "principalId",
                    "variableName": "principalId"
                  },
                  {
                    "kind": "Variable",
                    "name": "principalType",
                    "variableName": "principalType"
                  }
                ],
                "kind": "ObjectValue",
                "name": "principal"
              },
              {
                "kind": "Variable",
                "name": "roleId",
                "variableName": "roleId"
              }
            ],
            "kind": "ObjectValue",
            "name": "roleAssignment"
          },
          {
            "kind": "Variable",
            "name": "spaceTypes",
            "variableName": "spaceTypes"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkSetRoleAssignmentToSpacesPayload",
    "kind": "LinkedField",
    "name": "bulkSetRoleAssignmentToSpaces",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "taskId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5b790ed65d0de142da6e4d1622295fa",
    "id": "16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2",
    "metadata": {},
    "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
    "operationKind": "mutation",
    "text": "mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$roleId:ID!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId,principalType:$principalType},roleId:$roleId},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
  }
};
})();

(node as any).hash = "ed136028da75a75da2fb263f31962138";

export default node;
